import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { LotNoteGetCollectionByLotId, LotNoteGetCollectionByLotIdResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<LotNoteGetCollectionByLotIdResponse, LotNoteGetCollectionByLotIdResponse>) => {
    return response?.data?.lotNotes
}
const getError = (response?: SWRResponse<LotNoteGetCollectionByLotIdResponse, LotNoteGetCollectionByLotIdResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<LotGetCollectionByLotIdResponse, LotGetCollectionByLotIdResponse>) => ({});

const useLotNotesByLotId = (lotId: number, configuration?: SWRConfiguration<LotNoteGetCollectionByLotIdResponse, LotNoteGetCollectionByLotIdResponse>) => {
    
    const request = useMemo(() => {
        return () => {
            return new LotNoteGetCollectionByLotId({
                lotId: lotId
            });
        };
    }, [lotId])

    return useGet(request, { getData, getError }, configuration);
}

export default useLotNotesByLotId;